export function encodeUnicodeToBase64(str: string): string {
    const utf8Bytes: Uint8Array = new TextEncoder().encode(str); // Convert to UTF-8 bytes
    const binaryString: string = String.fromCharCode(...Array.from(utf8Bytes)); // Convert bytes to binary string
    return window.btoa(binaryString); // Convert binary string to Base64
}
